module.exports = __webpack_public_path__ + "static/media/star_big_white.1fe865db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/star_big_white.svg
// module id = 321
// module chunks = 2